import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=6fc37cea&scoped=true&"
import script from "./ResetPwd.vue?vue&type=script&lang=js&"
export * from "./ResetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=6fc37cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc37cea",
  null
  
)

export default component.exports